import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ForumsPage = lazy(() => import("./ForumsPage"));

const ForumsPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ForumsPage />
    </Suspense>
  );
};

export default ForumsPageLazy;
